import { createSlice } from "@reduxjs/toolkit";
import { Paging } from "types/common.types";

import { RootState } from "store/store";

import { getCalendarDates, getUserCalendar } from "./actions";
import { CalendarDate, CalendarItem } from "./types";

export type CalendarState = {
  error: any;
  loading: boolean;
  calendar: CalendarItem[];
  calendarDates: CalendarDate[];
  paging: Paging;
};

const initialState: CalendarState = {
  loading: false,
  error: false,
  paging: {} as Paging,
  calendar: [],
  calendarDates: [],
};

export const calendarSlice = createSlice({
  initialState,
  name: "calendar",
  reducers: {},
  extraReducers: (builder) => {
    //Get user calendar
    builder.addCase(getUserCalendar.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.calendar = action.payload.data;
      state.paging = action.payload.meta;
    });
    builder.addCase(getUserCalendar.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getUserCalendar.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });

    //Dates for sidebar calendar
    builder.addCase(getCalendarDates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getCalendarDates.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getCalendarDates.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.calendarDates = action.payload.data;
    });
  },
});

// Action creators are generated for each case reducer function
export default calendarSlice.reducer;

//Selectors
export const selectCalendar = (state: RootState) => state.calendar;
